import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form'
import { Input } from '@progress/kendo-react-inputs'
import { Label, Error, Hint } from '@progress/kendo-react-labels'
import { Spinner } from 'components'

const FormInput = (fieldRenderProps: FieldRenderProps) => {
  const { validationMessage, touched, label, id, valid, disabled, hint, type, optional, required, loading, inputPrefix, inputSuffix, ...others } = fieldRenderProps
  const showValidationMessage = touched && validationMessage
  const showHint = !showValidationMessage && hint
  const hintId = showHint ? `${id}_hint` : ''
  const errorId = showValidationMessage ? `${id}_error` : ''

  return (
    <FieldWrapper>
      {label &&
        <Label editorId={id} editorValid={valid} editorDisabled={disabled} optional={optional}>
          {required &&
            <span className='text-danger'>*</span>
          }
          {label} &nbsp;
          {
            showValidationMessage &&
            <Error id={errorId}>{validationMessage}</Error>
          }
        </Label>
      }
      <div className='k-form-field-wrap' style={{ position: 'relative' }}>
        {

          loading && <Spinner size='sm' style={{ position: 'absolute', top: '12px', right: '10px', zIndex: 999 }} />

        }
        {!inputPrefix && !inputSuffix
          ? <Input
            valid={valid}
            type={type}
            id={id}
            disabled={disabled}
            ariaDescribedBy={`${hintId} ${errorId}`}
            {...others}
          />
          : <div className='input-group d-flex'>

            {inputPrefix
              &&
              <div className='input-group-prepend'>
                <span className='input-group-text'>{inputPrefix}</span>
              </div>
            }
            <Input
              valid={valid}
              type={type}
              id={id}
              disabled={disabled}
              ariaDescribedBy={`${hintId} ${errorId}`}
              {...others}
              style={{ flex: 1, ...others.style }}
            />
            {inputSuffix
              &&
              <div className='input-group-append'>
                <span className='input-group-text' id='basic-addon2'>
                  {inputSuffix}
                </span>
              </div>
            }
          </div>
        }
        {
          showHint &&
          <Hint id={hintId}>{hint}</Hint>
        }
      </div>
    </FieldWrapper>
  )
}

export default FormInput